import { DialerCampaignI, DialerCampaignMailingI } from '@interfaces/dialer-campaign.interface';
import { environment } from '@environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PageI } from '@interfaces/page.interface';
import { FileImportMetaT } from '@omnitypes/file-import/file-import';

@Injectable({
  providedIn: 'root',
})
export class DialerCampaignService {
  private baseUrl = environment.OMNISMART_API_MARKETING_CAMPAIGN;
  private slug_url = 'dialer/';

  constructor(private http: HttpClient) {}

  public create(body: DialerCampaignI): Observable<DialerCampaignI> {
    return this.http.post<DialerCampaignI>(this.baseUrl + this.slug_url, body);
  }

  public getAll(
    search = '',
    sort = 'desc',
    page = 1,
    limit = 999,
    active = 'createdAt',
    status = ''
  ): Observable<PageI<DialerCampaignI>> {
    const params = new HttpParams()
      .set('search', search)
      .set('sort', sort)
      .set('active', active)
      .set('limit', limit.toString())
      .set('page', page.toString())
      .set('status', status);
    return this.http.get<PageI<DialerCampaignI>>(this.baseUrl + this.slug_url, {
      params,
    });
  }

  public getById(id: string): Observable<DialerCampaignI> {
    return this.http.get<DialerCampaignI>(this.baseUrl + this.slug_url + id);
  }

  public update(id: string, body: Partial<DialerCampaignI>): Observable<DialerCampaignI> {
    return this.http.patch<DialerCampaignI>(this.baseUrl + this.slug_url + id, body);
  }

  public delete(id: string): Observable<any> {
    return this.http.delete(this.baseUrl + this.slug_url + id);
  }

  public pause(id: string) {
    return this.http.post<any>(`${this.baseUrl}${this.slug_url}pause/${id}`, {});
  }

  public resume(id: string) {
    return this.http.post<any>(`${this.baseUrl}${this.slug_url}resume/${id}`, {});
  }

  public findAllStatus(): Observable<{ id: number; descricao: string; padrao_qtd_discagem: number }[]> {
    return this.http.get<{ id: number; descricao: string; padrao_qtd_discagem: number }[]>(
      `${this.baseUrl}dialer-status`,
      {}
    );
  }

  public importUpload(file: File): Observable<FileImportMetaT | undefined> {
    const formData = new FormData();
    formData.append('file', file, file.name);

    return this.http.post<FileImportMetaT | undefined>(`${this.baseUrl + this.slug_url}import/upload`, formData);
  }

  public importCommit(token: string, id: string, customFields?: Record<string, string>) {
    return this.http.post<any>(`${this.baseUrl + this.slug_url}import/commit/${token}`, {
      id,
      customFields: JSON.stringify(customFields),
    });
  }

  public importErrors(token: string) {
    return this.http.get<any>(`${this.baseUrl + this.slug_url}import/errors/${token}`);
  }

  public findOneExternal(campaign: string, idExternal: string): Observable<DialerCampaignMailingI> {
    const params = new HttpParams().set('campaign', campaign).set('idExternal', idExternal);

    return this.http.get<DialerCampaignMailingI>(
      `${this.baseUrl + 'dialer-mailing'}/find-one-external/${campaign}/${idExternal}`,
      {
        params,
      }
    );
  }
}
